<div class="global-search" #searchTarget>
  <app-svg-icon class="search-icon-overlay" icon="search" [size]="18" color="var(--color-grey-500)"></app-svg-icon>
  <dx-text-box
    #searchInput
    class="search-box"
    [value]="query()"
    [valueChangeEvent]="'input'"
    (onValueChanged)="onInput($event.value)"
    (onFocusIn)="onFocus()"
    (onKeyDown)="onKeydown($any($event).event)"
    [inputAttr]="searchInputAttr"
    [placeholder]="searchPlaceholder"
    [showClearButton]="!!query()"
  />

  <dx-popover
    #popover
    [target]="searchTarget"
    [visible]="popoverVisible()"
    (visibleChange)="popoverVisible.set($event)"
    [position]="{ my: 'left top', at: 'left bottom', offset: '0 6' }"
    [showTitle]="false"
    [width]="400"
    [maxHeight]="'72vh'"
    [shading]="false"
    [hideOnOutsideClick]="true"
    [wrapperAttr]="{ class: 'gpd-popover global-search-popover' }"
  >
    <div class="search-card">
      @if (availableScopes().length > 1) {
      <div class="scope-tabs">
        @for (scope of availableScopes(); track scope.key) {
        <gpd-pill
          class="scope-tab"
          [text]="scope.label"
          [backgroundColor]="searchScope() === scope.key ? 'var(--color-primary)' : '#ffffff'"
          [color]="searchScope() === scope.key ? '#ffffff' : 'var(--color-primary)'"
          [hasBorder]="searchScope() !== scope.key"
          (click)="setScope(scope.key)">
        </gpd-pill>
        }
      </div>
      }
      @if (loading()) {
      <div class="search-state">
        <span i18n="@@searchLoading">Searching…</span>
      </div>
      } @else if (!hasSearched()) {
      <!-- Recent searches (shown when input is focused with no active query) -->
      @if (recentSearches().length > 0) {
      <div class="recent-header">
        <span i18n="@@recentSearchesLabel">Recently searched</span>
        <app-gpd-button type="text" (onClick)="clearRecentSearches()" class="recent-clear-all" i18n-text="@@recentSearchesClear" text="Clear all"></app-gpd-button>
      </div>
      @for (term of recentSearches(); track term) {
      <div role="button" tabindex="0" class="recent-row" (click)="applyRecentSearch(term)" (keydown.enter)="applyRecentSearch(term)" (keydown.space)="$event.preventDefault(); applyRecentSearch(term)">
        <app-svg-icon icon="clock" [size]="16" color="var(--color-grey-400)"></app-svg-icon>
        <span class="recent-term">{{ term }}</span>
        <app-gpd-button type="text" class="recent-remove" icon="cancel" [iconSize]="14" iconColor="var(--color-grey-400)" (onClick)="removeRecentSearch(term, $event.event)" i18n-hint="@@searchRemoveRecent" hint="Remove"></app-gpd-button>
      </div>
      }
      }
      } @else if (flatItems().length === 0) {
      <!-- Only claim "no results" once every wave has landed: a query that matches only
           tasks (the slowest wave) would otherwise read as empty and be believed. -->
      @if (loadingSharePoint() || pendingWaves() > 0) {
      <div class="sp-loading-hint sp-loading-hint--standalone">
        <app-svg-icon icon="refresh" [size]="12" color="var(--color-grey-400)"></app-svg-icon>
        <span i18n="@@searchMoreLoading">Loading more results…</span>
      </div>
      } @else {
      <div class="search-state">
        <span i18n="@@searchNoResults">No results</span>
      </div>
      }
      } @else {
      <!-- Scrollable results; the "show all" footer below stays fixed -->
      <div class="search-scroll">
      @if (loadingSharePoint() || pendingWaves() > 0) {
      <div class="sp-loading-hint">
        <app-svg-icon icon="refresh" [size]="12" color="var(--color-grey-400)"></app-svg-icon>
        <span i18n="@@searchMoreLoading">Loading more results…</span>
      </div>
      }
        @for (group of groups(); track group.type) {
        <!-- Group header bar -->
        <div class="group-header">{{ group.label }} ({{ group.total }})</div>

        <!-- Result rows -->
        @for (item of group.items; track item.entityType + '-' + item.id) {
        <button type="button" class="result-row" [class.result-row-active]="isActive(item)" (click)="navigateTo(item, $event)">
          @if (item.authorEmail) {
            <app-user-avatar [userEmail]="item.authorEmail" [size]="32"></app-user-avatar>
          } @else {
          <div class="result-chip" [style.background-color]="group.chipBg">
            <app-svg-icon [icon]="group.icon" [size]="16" [color]="group.iconColor"></app-svg-icon>
          </div>
          }
          <div class="result-text">
            <div class="result-title" [title]="item.title" [innerHTML]="item.title | TextHighlight: query()"></div>
            @if (item.subtitle) {
            <div class="result-subtitle" [title]="item.subtitle" [innerHTML]="item.subtitle | TextHighlight: query()"></div>
            }
            @if (item.authorName) {
            <div class="result-subtitle">{{ item.authorName }}</div>
            }
            @if (item.context) {
            <div class="result-context" [title]="contextDisplay(item)">
              <app-svg-icon [icon]="(item.entityType === 'Contract' || item.entityType === 'UserTask' || item.entityType === 'ProjectCost' || item.entityType === 'Document' || item.entityType === 'SandboxDocument') ? 'note' : 'location'" [size]="12" color="var(--color-grey-500)"></app-svg-icon>
              <span [innerHTML]="contextDisplay(item) | TextHighlight: query()"></span>
            </div>
            }
          </div>
          @if (item.status) {
          <app-status-pill class="result-status" [statusId]="0" [statusConfig]="statusConfigFor(item.status)"></app-status-pill>
          }
        </button>
        }

        <!-- "show more" footer when there are additional matches -->
        @if (group.extra > 0) {
        <app-gpd-button type="text" class="result-more" [text]="showMoreLabel(group)" (onClick)="showMore(group)"></app-gpd-button>
        }
        }
      </div>

      <!-- Fixed footer: open the full results page for the current query -->
      <app-gpd-button type="secondary" class="result-show-all" i18n-text="@@searchShowAll" text="Show all results →" (onClick)="showAll()"></app-gpd-button>
      }
    </div>
  </dx-popover>
</div>
